// Core Components
import React from 'react';

// Material UI Components
import { makeStyles } from '@material-ui/core/styles';
import HelpIcon from '@material-ui/icons/Help';

const useStyles = makeStyles((theme) => ({
  titleBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  icon: {
    margin: theme.spacing(1),
  },
}));

export default function PageTitle(props) {
  const classes = useStyles();
  const { Icon, title } = props;
  const TitleIcon = Icon ? Icon : HelpIcon;

  return (
    <div className={classes.titleBox}>
      <TitleIcon className={classes.icon} />
      {title}
    </div>
  );
}
